module.exports = __webpack_public_path__ + "img/mask-group-22@1x.def8dc86.png";